// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"1fc1e377","176":"7d193b64","466":"023c51ac"}[chunkId] + ".js";
};